import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Typography } from '@material-ui/core';
import { ReactComponent as AddIcon } from '../../../../../assets/icons/person_add.svg';
import { jobsSelector } from '../../../../../store/selectors/jobsSelector';
import { getItemById } from '../../../../../utility/helpers';
import EventDate from '../eventDate';
import useStyles from '../styles';

const AddedToJob = ({ translations, record }) => {
  const classes = useStyles();
  const { candidates } = useSelector(jobsSelector);
  const candidate = getItemById(candidates || [], record.candidate);
  const eventLabel = candidate?.self_applied
    ? translations.appliedTo
    : translations.addedTo;

  return (
    <div className={classes.root}>
      <div className={classes.icon}>
        <AddIcon className={classes.eventIcon} />
      </div>
      <Typography
        className={classes.eventText}
        variant="body1"
        component="span"
      >
        {`${eventLabel} `}
        <Typography variant="subtitle1" component="span">
          {record.job_title}
        </Typography>
        {', '}
        <Typography variant="subtitle1" component="span">
          {record.step_title}
        </Typography>
      </Typography>
      <EventDate record={record} />
    </div>
  );
};

AddedToJob.propTypes = {
  translations: PropTypes.shape({}).isRequired,
  record: PropTypes.object.isRequired,
};

export default AddedToJob;
